import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import * as React from 'react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
import { logUsage } from 'owa-analytics';
import datapoints from '../datapoints';
var styles = require('./SubscriptionOptionFull.scss');
var classNames = require('classnames/bind').bind(styles);
var SubscriptionOptionFull = /** @class */ (function (_super) {
    tslib_1.__extends(SubscriptionOptionFull, _super);
    function SubscriptionOptionFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubscriptionOptionFull.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: classNames(styles.subscription_text_container, styles.premiumDashboard_text_content) }, strings.options_premium_SubscriptionContent),
            React.createElement("div", { className: styles.subscription_btn_container },
                React.createElement(PrimaryButton, { text: strings.options_premium_buttonText, "data-is-focusable": true, disabled: false, onClick: this.navigateToSubscriptions, className: styles.addNewItemButton }))));
    };
    SubscriptionOptionFull.prototype.navigateToSubscriptions = function (ev) {
        ev.stopPropagation();
        var accountServiceUrl = 'https://account.microsoft.com/services';
        logUsage(datapoints.PremiumDashManageSubscription.datapoint.name);
        window.open(accountServiceUrl, '_blank');
    };
    SubscriptionOptionFull = tslib_1.__decorate([
        observer
    ], SubscriptionOptionFull);
    return SubscriptionOptionFull;
}(React.Component));
export default SubscriptionOptionFull;
//# sourceMappingURL=SubscriptionOptionFull.js.map